import { IStorage } from "./IStorage";

export class IStorageMemoryShared extends IStorage
{
    static data: { [name: string]: string } = {};
    constructor()
    {
        super();
    }
    override get(name: string, defaultValue: string)
    {
        return IStorageMemoryShared.data[name] ?? defaultValue;
    }
    override set(name: string, value: string)
    {
        IStorageMemoryShared.data[name] = value;
    }
    override del(name: string)
    {
        delete IStorageMemoryShared.data[name];
    }
}